import { IForm } from 'core-components/classes/models/IForm'

export interface IFormHPContacts extends IForm {
  EntryId: number
  Email: string // SSO
  Business_Unit: string
  First_Name: string
  GeoRegion: string
  GeoMarket: string // Not exist in DB
  Last_Name: string
  LeadPBM: number
  Partner_ID: string
  Roles: string
  Source: string
}

export interface IHpContactManagement extends IForm {
  HasDuplicate: number
}

export interface IFormJBPSalesTeam extends IForm {
  EntryId: number
  PartnerId: string
  Email: string
  FirstName: string
  LastName: string
  BusinessUnit: string
  Roles: string
  LeadPBM: number
  TicketId: number
  TicketStatus: string
  Source: string // Not exist in view
}

export interface IFormJBPHPContactRoles extends IForm {
  UniqueId: string
  PartnerId: string
  Roles: string
  SortOrder?: number
}

export interface IFormJBPHPContactChangeRequest extends IForm {
  // Fields from ww_salesteam
  EntryId: number
  PartnerId: string
  PartnerName?: string
  Email: string
  FirstName: string
  LastName: string
  BusinessUnit: string // `/`separated values
  Roles: string
  LeadPBM: number
  ManagerEmail: string
  ManagerFirstName: string
  ManagerLastName: string
  AssignmentPeriod: string

  // Fields from 1217
  TicketId: number
  TicketStatus: string
  RequestAction: string // Add | Delete
  SignId?: string

  SortOrder?: number
}

export const JBPHPContactChangeRequestStatus = {
  New: 'New',
  Update: 'Update',
  WIP: 'WIP',
  Closed: 'Closed',
}

export const DEFAULT_HP_CONTACT_RESELLER_ROLE = 'Partner Business Manager'
export const DEFAULT_HP_CONTACT_DISTRIBUTOR_ROLE = 'Distribution Account Manager'
export const DEFAULT_HP_CONTACT_RETAIL_ROLE = 'Retail Account Manager'

export const newHpContactRequest: IFormJBPHPContactChangeRequest = {
  // Fields from ww_salesteam
  EntryId: -1,
  PartnerId: '',
  PartnerName: '',
  Email: '',
  FirstName: '',
  LastName: '',
  BusinessUnit: '',
  Roles: DEFAULT_HP_CONTACT_RESELLER_ROLE,
  LeadPBM: 0,
  AssignmentPeriod: '',
  ManagerEmail: '',
  ManagerFirstName: '',
  ManagerLastName: '',

  // Fields from 1217
  TicketId: -1,
  TicketStatus: '',
  RequestAction: '',
  SignId: '',
}
